import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2, Heart, Sparkles, Users } from 'lucide-react';
import { ReservationForm } from '../components/ReservationForm';
const trustItems = [{
  icon: CheckCircle2,
  title: 'Confirmación inmediata',
  text: 'Recibe la confirmación al instante en tu correo.'
}, {
  icon: Heart,
  title: 'Trato cercano',
  text: 'Te recibimos como en casa, con todo preparado.'
}, {
  icon: Sparkles,
  title: 'Ocasiones especiales',
  text: 'Cuéntanos qué celebras y prepararemos un detalle.'
}];
export function Reservas() {
  return <div className="py-12 md:py-20" data-id="element-445">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-446">
        <div className="text-center max-w-2xl mx-auto mb-12" data-id="element-447">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} className="inline-flex items-center gap-2 px-4 py-2 mb-6 rounded-full bg-cafe-card border border-cafe-border text-sm text-cafe-text/80" data-id="element-448">
            <Users size={14} className="text-cafe-accent" data-id="element-449" />
            <span data-id="element-450">Reservas solo para grupos de 6 o más</span>
          </motion.div>
          <motion.h1 initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} className="text-4xl md:text-5xl font-serif text-cafe-primary mb-6" data-id="element-451">
            Reservas para grupos
          </motion.h1>
          <motion.p initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: 0.1
        }} className="text-lg text-cafe-text/80" data-id="element-452">
            ¿Vais a venir varios? Reserva con antelación y dejaremos todo
            preparado para vuestro grupo. Para mesas más pequeñas, ven sin
            reserva — siempre te haremos sitio.
          </motion.p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-3 gap-6 max-w-4xl mx-auto mb-14" data-id="element-453">
          {trustItems.map((item, i) => <motion.div key={item.title} initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: 0.2 + i * 0.1,
          duration: 0.5
        }} className="text-center px-4" data-id="element-454">
              <div className="w-12 h-12 mx-auto bg-cafe-card rounded-full flex items-center justify-center mb-3" data-id="element-455">
                <item.icon className="text-cafe-accent" size={22} data-id="element-456" />
              </div>
              <h3 className="font-serif text-cafe-primary text-base mb-1" data-id="element-457">
                {item.title}
              </h3>
              <p className="text-cafe-text/70 text-sm leading-relaxed" data-id="element-458">
                {item.text}
              </p>
            </motion.div>)}
        </div>

        <ReservationForm data-id="element-459" />
      </div>
    </div>;
}